import { getFormattedDate } from "../../../../../common/utils/helpers/getFormattedDate";

/**
 * Maps Swiss Travel Pass passenger form state into the estimation API shape.
 * Formats birthdate as a local `yyyy-MM-dd` string (avoids UTC day-shift from Date.toISOString()).
 */
export function mapSwissTravelPassPassengersForApi(passengerList: Array<any>) {
  return (Array.isArray(passengerList) ? passengerList : []).map((passenger: any) => ({
    first_name: passenger?.firstName,
    last_name: passenger?.lastName,
    birthdate: getFormattedDate(passenger?.birthDate),
    countryOfResidence: JSON.parse(passenger?.countryOfResidence)?.code,
    member_card: false
  }));
}
